
import iconFilter from '../../../assets/images/InvestmentPortfolio/icon-filter.png'
import iconList from '../../../assets/images/InvestmentPortfolio/icon-list.svg'
import { ReactComponent as Iconnganhan } from '../../../assets/images/InvestmentPortfolio/icon-nganhan.svg'
import { ReactComponent as Icontrunghan } from '../../../assets/images/InvestmentPortfolio/icon-trunghan.svg'
import { ReactComponent as Icondaihan } from '../../../assets/images/InvestmentPortfolio/icon-daihan.svg'

import './DSCStock.scss'

import { useState } from 'react'
import StockFilter from './DSCStock/StockFilter'
import RecommendedDSC from './DSCStock/RecommendedDSC'
import PersonalDirectoryMobile from './DSCStock/PersonalDirectoryMobile'

export default function DSCStock() {
  const [tabActive, setTabActive] = useState('tab1');
  const [tabActiveMobile, setTabActiveMobile] = useState('tab2');

  const handleChageTab = (tab: string) => {
    setTabActive(tab)
  }

  const handleChageTabMobile = (tab: string) => {
    setTabActiveMobile(tab)
  }

  return (
    <>
      <div className='wjndytqlbg'>
        <div className='wnovilarnl'>
          <div onClick={() => handleChageTab('tab1')} className={`bwdvpuosst ${tabActive === 'tab1' ? 'W6y0avIBBG' : ''}`}>
            <img src={iconFilter} alt='' className='qunivyndnj' /> Bộ lọc cổ phiếu DSC
          </div>
          <div onClick={() => handleChageTab('tab5')} className={`bwdvpuosst Ep5k2V4Ow8 ${tabActive === 'tab5' ? 'W6y0avIBBG' : ''}`}>
            <img src={iconList} alt='' className='qunivyndnj' /> Danh mục cá nhân
          </div>
        </div>
        <div className='iWFYoAzGpS'>
          <div onClick={() => handleChageTabMobile('tab2')} className={`lyKIupqeom ${tabActiveMobile === 'tab2' ? 'HTqqQKDXGZ' : ''}`}>
            <Iconnganhan className={`tcVFyMVFOL ${tabActiveMobile === 'tab2' ? 'nYUxrIasdN' : ''}`} />
            <span className='XcSkqzocsK'>Ngắn hạn</span>
          </div>
          <div onClick={() => handleChageTabMobile('tab3')} className={`lyKIupqeom ${tabActiveMobile === 'tab3' ? 'HTqqQKDXGZ' : ''}`}>
            <Icontrunghan className={`tcVFyMVFOL ${tabActiveMobile === 'tab3' ? 'GoyMyGSuTA' : ''}`} />
            <span className='XcSkqzocsK'>Trung hạn</span>
          </div>
          <div onClick={() => handleChageTabMobile('tab4')} className={`lyKIupqeom ${tabActiveMobile === 'tab4' ? 'HTqqQKDXGZ' : ''}`}>
            <Icondaihan className={`tcVFyMVFOL ${tabActiveMobile === 'tab4' ? 'LkzUwWPzgP' : ''}`} />
            <span className='XcSkqzocsK'>Dài hạn</span>
          </div>
        </div>
        <div className='zR0l2lReYh'>{tabActive === 'tab1' ? <StockFilter /> : ''}</div>
        <div className='zR0l2lReYh'>{tabActive === 'tab2' ? <RecommendedDSC /> : ''}</div>
        <div className='zR0l2lReYh'>{tabActive === 'tab3' ? <RecommendedDSC /> : ''}</div>
        <div className='zR0l2lReYh'>{tabActive === 'tab4' ? <RecommendedDSC /> : ''}</div>
        <div className='DpEMaslHjJ Ep5k2V4Ow8'>{tabActive === 'tab5' ? <PersonalDirectoryMobile /> : ''}</div>
      </div>
    </>
  )
}